import { render, staticRenderFns } from "./FieldDisplay.vue?vue&type=template&id=bb51e272"
import script from "./FieldDisplay.vue?vue&type=script&lang=js"
export * from "./FieldDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports